/**
 * The one wallet, as a service's own card shows it (`billing-card.tsx`).
 */

import { Link } from 'react-router-dom';
import { formatMoney } from '@connect/web-shared';

/**
 * Where a service's own card shows the one wallet: its balance and what this
 * service took. Top-ups and the alert are the wallet's, under Wallet & credits.
 */
export function ServiceSpend({
  balance,
  currency,
  low,
  spent,
}: {
  balance: string;
  currency: string;
  low: boolean;
  spent: string;
}) {
  return (
    <div className="grid gap-3 sm:grid-cols-3">
      <div>
        <p className="text-2xs uppercase tracking-wide text-muted">Wallet balance</p>
        <p className={low ? 'text-lg font-semibold text-warning' : 'text-lg font-semibold text-heading'}>
          {formatMoney(balance, currency)}
        </p>
      </div>
      <div>
        <p className="text-2xs uppercase tracking-wide text-muted">This service, 30 days</p>
        <p className="text-sm text-body">{formatMoney(spent, currency)}</p>
      </div>
      <p className="self-end text-xs text-muted">
        One wallet for every service. Top-ups and the low-balance alert are under{' '}
        <Link className="text-accent hover:underline" to="?area=billing">
          Wallet &amp; credits
        </Link>
        .
      </p>
    </div>
  );
}
